import {fetchEmployeeAudit} from "../dataLayer/audit";
import { Audit } from "../interfaces/AuditInterface";

class AuditManager {

    // Method to fetch audits for an employee
    async getEmployeeAudit(employeeID: string, payPeriodID: number): Promise<Audit[]> {
        try {
            // Call the API layer to fetch the audits
            const audits: Audit[] = await fetchEmployeeAudit(employeeID, payPeriodID);

            // Return the fetched audits
            return audits;
        } catch (err) {
            console.error("Error fetching employee audit:", err);
            throw err; // Rethrow the error after logging it
        }
    }

}

export default new AuditManager();  // Exporting an instance of the manager class
